import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { PageEvent } from '@angular/material/paginator';
import { FormGroup, FormControl } from '@angular/forms';
import { UtilsService } from 'src/app/shared/utils.service';
import { DataService } from 'src/app/shared/data.service';
import { AuthService } from 'src/app/auth/auth.service';
import { ActivatedRoute, Router, Params } from '@angular/router';
import { AlertDialogComponent } from 'src/app/shared/alert-dialog/alert-dialog.component';
import { ConfirmDialogComponent } from 'src/app/shared/confirm-dialog/confirm-dialog.component';
import { User } from 'src/app/auth/user.model';
import { AddEditMaterialComponent } from '../product-training-materials/add-edit-material/add-edit-material.component';
import { MaterialDetailsComponent } from '../product-training-materials/material-details/material-details.component';

@Component({
    selector: 'app-product-marketing-materials',
    templateUrl: './product-marketing-materials.component.html',
    styleUrls: ['./product-marketing-materials.component.scss'],
    standalone: false
})
export class ProductMarketingMaterialsComponent implements OnInit {
  pageEvent!: PageEvent;
  searchForm!: FormGroup;
  showSearch: boolean;
  pageSize = 10;
  pageNumber = 1;
  totalSize = 0;
  userID: number;
  materialsList = new Array<any>();
  queryParams: {
    pageNumber: number;
    pageSize: number;
    searchValue: string | null;
    usedOnMobile: boolean | null;
  } = {
    pageNumber: 0,
    pageSize: 0,
    searchValue: null,
    usedOnMobile: null
  };

  searchValue = "";
  productId: any;
  selected = 'manufacturer';
  usedOnMobile = null;
  user: User;
  productName: any;
  materialId = null;

  constructor(public dialog: MatDialog, public utils: UtilsService,
              public dataService: DataService,
              public authService: AuthService,
              private route: ActivatedRoute,
              private router: Router) {
                this.showSearch = false;
                this.user = this.authService.getUserData();
                this.userID = this.user.id;
                this.productId = router.routerState.snapshot.root.children[0].children[0].params.id;
                this.productName = router.routerState.snapshot.root.children[0].children[0].params.name;
                this.route.queryParams.subscribe((params: Params) => {
                    if (!this.isEmpty(params)) {
                      this.materialId = params.materialId ? params.materialId : null;
                      this.pageNumber = params.pageNumber ? params.pageNumber : 1;
                      this.pageSize = params.pageSize ? params.pageSize : 10;
                      this.searchValue =  params.searchValue ? params.searchValue : "";
                      this.usedOnMobile = params.usedOnMobile;
                      this.selected = params.usedOnMobile === 'true'  ? 'usedOnMobile'  : 'manufacturer';
                      if (params.usedOnMobile === undefined) {
                        if (this.user.type === this.utils.userTypes.Distributor) {
                          this.usedOnMobile = true;
                        } else {
                          this.usedOnMobile = null;
                        }
                        this.selected = 'usedOnMobile';
                      }
                    } else {
                      if (this.user.type === this.utils.userTypes.Distributor) {
                        this.selected = 'usedOnMobile';
                        this.usedOnMobile = true;
                      }
                    }
                    this.getMaterial();
                    if (this.materialId) {
                      this.openMaterialDetails(this.materialId);
                    }
                  });
                }
  ngOnInit(): void {
    this.utils.setTitle('Products');
    this.utils.screenTitle.emit({firstTitle: 'Products', firstRoute: '/products',
        secondTitle: this.productName, secondRoute: '/products/product/' + this.productId + '/' + this.productName + '/general',
      });
    this.searchForm = new FormGroup({
      search: new FormControl(this.searchValue),
    });

    if (this.searchValue) {
      this.showSearch = true;
    }
    
    this.searchForm.get('search')?.valueChanges.subscribe(value => {
      const newValue = (value || '').trim();
      if (newValue === '' && this.searchValue !== '') {
        setTimeout(() => this.clearSearch(), 0);
      }
    });
  }

  isEmpty(obj: any) {
    return Object.keys(obj).length === 0;
  }

  handlePage(e: any) {
    this.pageNumber = e.pageIndex + 1;
    this.pageSize = e.pageSize;
    this.queryParams = {pageNumber: this.pageNumber, pageSize: this.pageSize,
      searchValue: this.searchValue, usedOnMobile: this.usedOnMobile};
    this.router.navigate(['/products/product/' + this.productId + '/'   + this.productName +
        '/marketing-materials'], { queryParams: this.queryParams });
  }

  filterChange(value: any) {
    this.selected = value;
    if (value === 'manufacturer') {
      this.usedOnMobile = false;
      this.pageNumber = 1;
      this.queryParams = {pageNumber: this.pageNumber, pageSize: this.pageSize,
        searchValue: this.searchValue, usedOnMobile: this.usedOnMobile};
      this.router.navigate(['/products/product/' + this.productId + '/'   + this.productName +
        '/marketing-materials'], { queryParams: this.queryParams });    } else if (value === 'usedOnMobile') {
      this.usedOnMobile = true;
      this.pageNumber = 1;
      this.queryParams = {pageNumber: this.pageNumber, pageSize: this.pageSize,
        searchValue: this.searchValue, usedOnMobile: this.usedOnMobile};
      this.router.navigate(['/products/product/' + this.productId + '/'   + this.productName +
        '/marketing-materials'], { queryParams: this.queryParams });    }
  }

  handleSearchClick() {
    if (this.showSearch) {
      this.doSearch();
    } else {
      this.showSearch = true;
    }
  }

  doSearch() {
    let searchInput = this.searchForm.get('search')?.value || '';
    this.searchValue = searchInput.trim();
    this.searchForm.get('search')?.setValue(this.searchValue, { emitEvent: false });
    
    if (this.searchValue && this.materialsList.length > 0) {
      this.pageNumber = 1;
      this.queryParams = {pageNumber: this.pageNumber, pageSize: this.pageSize,
        searchValue: this.searchValue, usedOnMobile: this.usedOnMobile};
      this.router.navigate(['/products/product/' + this.productId + '/'   + this.productName +
        '/marketing-materials'], { queryParams: this.queryParams });    }
  }

  openMaterialDetails(id: any) {
    const dialogRef = this.dialog.open(MaterialDetailsComponent, {disableClose: true, width: '600px', data: {id,
      productId: this.productId, page: 'marketing'}});
    dialogRef.afterClosed().subscribe((newEvent) => {});
  }
  openAddMaterial() {
    const dialogRef = this.dialog.open(AddEditMaterialComponent, {
      disableClose: true,
      width: '400px',
      data: {
        type: 'Add',
        page: 'marketing',
        productId: this.productId
      }
    });
    dialogRef.afterClosed().subscribe((newMaterial) => {
      if (newMaterial) {
        if (this.user.type === this.utils.userTypes.Manufacturer) {
          this.materialsList.unshift(newMaterial);
          this.totalSize = this.totalSize + 1;
          if (this.materialsList.length <= this.pageSize) {
          } else {
            this.materialsList.splice(this.materialsList.length - 1, 1);
          }
        } else {
          if (this.selected === 'usedOnMobile') {
            this.materialsList.unshift(newMaterial);
            this.totalSize = this.totalSize + 1;
            if (this.materialsList.length <= this.pageSize) {
            } else {
              this.materialsList.splice(this.materialsList.length - 1, 1);
            }
          }
        }
        this.getMaterial();
      }
    });
  }

  openEditMaterial(id: any, material: any) {
    const dialogRef = this.dialog.open(AddEditMaterialComponent, {
      disableClose: true,
      width: '400px',
      data: {
        type: 'Edit',
        id,
        material,
        page: 'marketing',
        productId: this.productId
      }
    });
    dialogRef.afterClosed().subscribe((editedMaterial) => {
      if (editedMaterial && editedMaterial.materialId) {
        this.getMaterial();
      }
    });
  }

  deleteMaterial(id: any) {
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      disableClose: true,
      width: '400px',
      data: {
        title: 'Delete',
        page: 'training',
      }
    });
    dialogRef.afterClosed().subscribe((status) => {
      if (status) {
        if (status === 'accept') {
          this.dataService.delete('product/marketingMaterial/DeleteMarketingMaterial/' + this.productId + '/' + id).then((data: any) => {
            if (data.statusCode === 200) {
              this.materialsList.forEach( (material, index) => {
                if (material.id === id) {
                  this.materialsList.splice(index, 1);
                  if (this.materialsList.length === 0 && this.pageNumber > 1) {
                    this.pageNumber = this.pageNumber - 1;
                    this.queryParams = {pageNumber: this.pageNumber, pageSize: this.pageSize,
                      searchValue: this.searchValue, usedOnMobile: this.usedOnMobile};
                    this.router.navigate(['/products/product/' + this.productId + '/'   + this.productName +
                      '/marketing-materials'], { queryParams: this.queryParams });                  } else {
                    this.getMaterial();
                  }
                }
              });
              const dialogRef = this.dialog.open(AlertDialogComponent, {
                disableClose: true,
                width: '400px',
                data: {
                  title: 'Success',
                  type: 'Success',
                  message: 'Marketing material deleted successfully',
                  buttonText: 'Ok'
                }
              });
            } else {
              const dialogRef = this.dialog.open(AlertDialogComponent, {
                disableClose: true,
                width: '400px',
                data: {
                  title: 'Error',
                  type: 'Error',
                  message: 'Something went wrong, Please try again!',
                  buttonText: 'Ok'
                }
              });
            }
          });
        }
      }
    });
  }

  moveToUsedOnMobile(id: any) {
    this.dataService.put('product/marketingMaterial/UpdateUsedOnMobile', {
      materialId : id,
      productId : parseInt(this.productId.toString(), 10),
      usedOnMobile : true
    }).then((data: any) => {
      if (data.statusCode === 200) {
        const dialogRef = this.dialog.open(AlertDialogComponent, {
          disableClose: true,
          width: '400px',
          data: {
            title: 'Success',
            type: 'Success',
            message: 'Used on mobile enabled successfully.',
            buttonText: 'Ok'
          }
        });
        this.getMaterial();
      }
    });
  }

  moveToNotUsedOnMobile(id: any) {
    this.dataService.put('product/marketingMaterial/UpdateUsedOnMobile', {
      materialId : id,
      productId : parseInt(this.productId.toString(), 10),
      usedOnMobile : false
    }).then((data: any) => {
      if (data.statusCode === 200) {
        const dialogRef = this.dialog.open(AlertDialogComponent, {
          disableClose: true,
          width: '400px',
          data: {
            title: 'Success',
            type: 'Success',
            message: 'Used on mobile disabled successfully',
            buttonText: 'Ok'
          }
        });
        this.getMaterial();
      }
    });
  }

  clearSearch() {
    this.showSearch = !this.showSearch;
    this.searchForm.get('search')?.setValue('');
    this.searchValue = '';
    this.pageNumber = 1;
    this.queryParams = {
      pageNumber: this.pageNumber,
      pageSize: this.pageSize,
      searchValue: this.searchValue,
      usedOnMobile: this.usedOnMobile
    };
    this.router.navigate(['/products/product/' + this.productId + '/'   + this.productName +
      '/marketing-materials'], { queryParams: this.queryParams });
  }

  getMaterial() {
    if (this.usedOnMobile ===  null) {
      this.dataService.get('product/marketingMaterial/RetrieveMarketingMaterials/' +
      parseInt(this.productId.toString(), 10) + '?pageNumber=' + this.pageNumber +
      '&pageSize=' + this.pageSize +
      '&searchKeyword=' + this.searchValue +
      '&AddedBy=2').then((data: any) => {
        if (data.statusCode === 200) {
          this.materialsList = [];
          const materialsData = data.data.records;
          this.totalSize = data.data.count;
          materialsData.forEach((materialData: any) => {
            // const referenceInstance = new Reference(referenceData);
            this.materialsList.push(materialData);
          });
          if (materialsData.length === 0 && this.totalSize > 0) {
            this.pageNumber = 1;
            this.queryParams = {pageNumber: this.pageNumber, pageSize: this.pageSize,
              searchValue: this.searchValue, usedOnMobile: this.usedOnMobile};
            this.router.navigate(['/products/product/' + this.productId + '/'   + this.productName +
              '/marketing-materials'], { queryParams: this.queryParams });          }
        }
      });
    } else {
      let addedBy = this.usedOnMobile === "true" ? '4' : '2';
      if (this.usedOnMobile === true) {
        addedBy = '4';
      }
      this.dataService.get('product/marketingMaterial/RetrieveMarketingMaterials/' +
      parseInt(this.productId.toString(), 10) + '?pageNumber=' + this.pageNumber +
      '&pageSize=' + this.pageSize +
      '&searchKeyword=' + this.searchValue +
      '&usedOnMobile=' + this.usedOnMobile +
      '&AddedBy=' + addedBy).then((data: any) => {
        if (data.statusCode === 200) {
          this.materialsList = [];
          const materialsData = data.data.records;
          this.totalSize = data.data.count;
          materialsData.forEach((materialData: any) => {
            // const referenceInstance = new Reference(referenceData);
            this.materialsList.push(materialData);
          });
          if (materialsData.length === 0 && this.totalSize > 0) {
            this.pageNumber = 1;
            this.queryParams = {pageNumber: this.pageNumber, pageSize: this.pageSize,
              searchValue: this.searchValue, usedOnMobile: this.usedOnMobile};
            this.router.navigate(['/products/product/' + this.productId + '/'   + this.productName +
              '/marketing-materials'], { queryParams: this.queryParams });          }
        }
      });
    }
  }

}

